import { useEffect, useState } from "react";
import api, { API_BASE } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { FileDown } from "lucide-react";

export default function AssocInvoices() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/invoices").then(({ data }) => setItems(data)); }, []);

  const downloadPdf = async (inv) => {
    const token = localStorage.getItem("ss_token");
    const res = await fetch(`${API_BASE}/invoices/${inv.id}/pdf`, { headers: { Authorization: `Bearer ${token}` } });
    if (!res.ok) return;
    const blob = await res.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a"); a.href = url; a.download = `${inv.number}.pdf`; a.click();
  };

  return (
    <div className="space-y-6" data-testid="assoc-invoices">
      <div>
        <div className="overline text-accent">Comptabilitat</div>
        <h1 className="mt-2 text-3xl font-heading font-bold tracking-tight">Les meves factures</h1>
      </div>
      <Card className="rounded-2xl border-2 overflow-hidden">
        <CardContent className="p-0">
          <Table>
            <TableHeader>
              <TableRow><TableHead>Núm.</TableHead><TableHead>Emissió</TableHead><TableHead>Venciment</TableHead><TableHead>Import</TableHead><TableHead>Estat</TableHead><TableHead></TableHead></TableRow>
            </TableHeader>
            <TableBody>
              {items.map(inv => (
                <TableRow key={inv.id} data-testid={`assoc-invoice-${inv.number}`}>
                  <TableCell className="font-mono text-xs">{inv.number}</TableCell>
                  <TableCell className="text-xs">{inv.issue_date}</TableCell>
                  <TableCell className="text-xs">{inv.due_date}</TableCell>
                  <TableCell className="font-semibold">{inv.total.toFixed(2)} €</TableCell>
                  <TableCell><span className={`text-xs px-2 py-1 rounded-full ${inv.payment_status === "paid" ? "bg-emerald-100 text-emerald-700" : "bg-amber-100 text-amber-700"}`}>{inv.payment_status}</span></TableCell>
                  <TableCell>
                    <Button size="sm" variant="outline" className="rounded-full" onClick={() => downloadPdf(inv)} data-testid={`assoc-invoice-pdf-${inv.number}`}>
                      <FileDown className="w-3.5 h-3.5 mr-1" /> PDF
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
              {items.length === 0 && <TableRow><TableCell colSpan={6} className="text-center py-8 text-muted-foreground">Sense factures.</TableCell></TableRow>}
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    </div>
  );
}
